export const VEHICLE_STATUS = [

  {
    value: "active",
    label: "Activo"
  },

  {
    value: "maintenance",
    label: "En mantenimiento"
  },

  {
    value: "out_of_service",
    label: "Fuera de servicio"
  }

];